import React, { Component, createRef } from "react";
import Dropzone from "react-dropzone";
import { Alert } from "reactstrap";
import { Button, Card, CardBody, Col, Container, Label, Row } from "reactstrap";

import { Link } from "react-router-dom";
import Notification from "../Common/Notification";
import { Formik, Field, Form, ErrorMessage } from "formik";
import * as Yup from "yup";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";
import {
  createUser,
  updateUser,
  getUnitAPI,
  getRoleAPI,
  getUserTimeShiftAPI,
  baseUrl,
} from "api";
import { withTranslation } from "react-i18next";

class AddUser extends Component {
  constructor(props) {
    console.log(props);
    super(props);
    this.state = {
      ...this.props,
      firstSubmit: false,
      validation: "",
      showNotification: false,
      notificationMessage: "",
      factoryList: [],
      roleList: [],
      userTimeShiftList: [],
      props: props?.location?.query
        ? props?.location?.query
        : { isEdit: false, isView: false, data: null },
      selectedFiles: [],
    };
    this.filesharhe_ref = createRef();
    // this.handleSubmit = this.handleSubmit.bind(this);
    this.onChangeValidation = this.onChangeValidation.bind(this);
  }

  async componentDidMount() {
    if (
      this.state?.props?.data?.photo &&
      this.state?.props?.data?.photo != "null"
    ) {
      this.setState({
        selectedFiles: [
          {
            preview: `${baseUrl}/uploads/${this.state.props.data.photo}`,
          },
        ],
      });
    }
    const factory = await getUnitAPI({ isInternal: true });
    const role = await getRoleAPI();
    const userTimeShift = await getUserTimeShiftAPI();
    this.setState({
      factoryList: factory.data.factories,
      roleList: role.data,
      userTimeShiftList: userTimeShift.data,
    });
  }

  handleAcceptedFiles = files => {
    files.map(file =>
      Object.assign(file, {
        preview: URL.createObjectURL(file),
        formattedSize: this.formatBytes(file.size),
      })
    );

    this.setState({ selectedFiles: files });
  };

  formatBytes = (bytes, decimals = 2) => {
    if (bytes === 0) return "0 Bytes";
    const k = 1024;
    const dm = decimals < 0 ? 0 : decimals;
    const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"];

    const i = Math.floor(Math.log(bytes) / Math.log(k));
    return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
  };

  handleSubmit = async (e, values) => {
    console.log(values);
    e.preventDefault();
    if (this.state.props.isEdit == false) {
      delete values.id;
      let formdata = new FormData();
      delete values.confirmpassword;
      Object.keys(values).forEach(x => formdata.append(x, values[x]));
      if (this.state.selectedFiles.length)
        formdata.append("photo", this.state.selectedFiles[0]);
      const data = await createUser(formdata);
      if (data.data && data.success) {
        // formikHelpers.setValues({
        //   ...values,
        //   id: data.data.id,
        // });
      }
      this.props.history.push("/user-list");
    } else {
      delete values.factory;
      delete values.role;
      delete values.userTimeShift;
      delete values.createdAt;
      delete values.updatedAt;
      delete values.confirmpassword;
      delete values.otp;
      delete values.otpValid;

      let formdata = new FormData();

      Object.keys(values).forEach(x => formdata.append(x, values[x]));

      if (this.state.selectedFiles.length) {
        formdata.delete("photo");
        if ("formattedSize" in this.state.selectedFiles[0])
          formdata.append("photo", this.state.selectedFiles[0]);
      }
      if (formdata.get("photo") == "null") formdata.delete("photo");
      const data = await updateUser({ id: formdata.get("id"), data: formdata });
    }
  };

  //for change tooltip display propery
  onChangeValidation(fieldName, value) {
    const modifiedV = { ...this.state.validation };
    if (value !== "") {
      modifiedV[fieldName] = true;
    } else {
      modifiedV[fieldName] = false;
    }
    this.setState({ validation: modifiedV });
  }

  render() {
    //meta title
    document.title =
      this.state.props.isEdit == false ? "Add user" : "Edit user";
    const { validation } = this.state;
    return (
      <React.Fragment>
        <div className="page-content">
          <Alert isOpen={this.state.showNotification}>
            {this.state.notificationMessage}
          </Alert>
          <Container fluid={true}>
            <Breadcrumbs breadcrumbItem={this.props.t("Manage User")} />
            <Row>
              <Col xl="12">
                <Card>
                  <CardBody>
                    <Formik
                      enableReinitialize={true}
                      initialValues={
                        this.state.props.data == null
                          ? {
                              name: "",
                              roleId: "",
                              id: "",
                              factoryId: "",
                              userTimeShiftId: "",
                              gender: "",
                              mobileNo1: "",
                              mobileNo2: "",
                              email: "",
                              password: "",
                              confirmpassword: "",
                              addressLine1: "",
                              addressLine2: "",
                              city: "",
                              state: "",
                              zipCode: "",
                              status: true,
                              notes: "",
                              originalProcessName: false,
                            }
                          : this.state.props.data
                      }
                      validationSchema={Yup.object().shape({
                        photo: Yup.string()
                          .nullable()
                          .notRequired()
                          .test(
                            "FILE_SIZE",
                            "Uploaded file is too big.",
                            value => !value || (value && value.size <= 500000)
                          )
                          .test(
                            "FILE_FORMAT",
                            "Uploaded file has unsupported format.",
                            value =>
                              !value ||
                              (value &&
                                ["jpg", "jpeg", "png"].includes(value.type))
                          ),
                        name: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your Name"),
                        roleId: Yup.string().required(
                          "Please Select User Role"
                        ),
                        id: Yup.string().notRequired(),
                        factoryId: Yup.string().required(
                          "Please Enter Your Factory name"
                        ),
                        userTimeShiftId: Yup.string().nullable().notRequired(),
                        gender: Yup.string().required(
                          "Please Select your gender"
                        ),
                        mobileNo1: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .required("Please Enter Your Mobile Number"),
                        mobileNo2: Yup.number()
                          .min(1111111111)
                          .max(9999999999)
                          .nullable()
                          .notRequired(),
                        email: Yup.string()
                          .min(1)
                          .max(50)
                          .required("Please Enter Your email"),
                        password:
                          this.state.props.isEdit === false
                            ? Yup.string()
                                .required("Password is required")
                                .min(5, "Your password is too short.")
                                .matches(
                                  "(?=.*[!@#$%^&*])",
                                  "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                                )
                            : Yup.string()
                                .notRequired()
                                .min(5, "Your password is too short.")
                                .matches(
                                  "(?=.*[!@#$%^&*])",
                                  "Must Contain 8 Characters, One Uppercase, One Lowercase, One Number and one special case Character"
                                ),
                        confirmpassword:
                          this.state.props.isEdit === false
                            ? Yup.string()
                                .required()
                                .oneOf(
                                  [Yup.ref("password"), null],
                                  "Passwords must match"
                                )
                            : Yup.string()
                                .notRequired()
                                .oneOf(
                                  [Yup.ref("password"), null],
                                  "Passwords must match"
                                ),
                        addressLine1: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your Address"),

                        zipCode: Yup.number()
                          .min(1)
                          .max(999999)
                          .nullable()
                          .notRequired(),
                        addressLine2: Yup.string()
                          .min(1)
                          .max(255)
                          .nullable()
                          .notRequired(),
                        city: Yup.string()
                          .min(1)
                          .max(255)
                          .required("Please Enter Your city"),
                        state: Yup.string()
                          .min(1)
                          .max(32767)
                          .required("Please Enter Your state"),
                        notes: Yup.string()
                          .min(1)
                          .max(255)
                          .nullable()
                          .notRequired(),
                      })}
                      onSubmit={async (values, formikHelpers) => {}}
                    >
                      {({
                        errors,
                        touched,
                        values,
                        isValid,
                        submitCount,
                        validateForm,
                      }) => (
                        <Form className="needs-validation">
                          <Row>
                            <h4 className="pb-3 text-black fw-bold">
                              <div className="d-flex flex-row mb-4 justify-content-between">
                                <div>
                                  <h4 className="text-black fw-bold mb-4">
                                    {this.state.props.isView ||
                                    this.state.props.isEdit
                                      ? this.state.props.isEdit
                                        ? `${this.props.t("Edit User Details")}`
                                        : `${this.props.t("View User Details")}`
                                      : `${this.props.t("Add User Details")}`}
                                  </h4>
                                </div>
                                <div>
                                  <div className="d-inline-block me-3 fs-5 fw-bold">
                                    Active
                                  </div>
                                  <div className="form-check form-switch d-inline-block">
                                    <Field
                                      className="form-check-input fs-5"
                                      type="checkbox"
                                      name="status"
                                      disabled={
                                        this.state.props.isView ? true : false
                                      }
                                    />
                                    <label className="form-check-label pt-4"></label>
                                  </div>
                                </div>
                              </div>
                            </h4>
                            <div className="mb-3 row">
                              {this.state.props.isView ? (
                                <>
                                  {this.state.props.data.photo != null ? (
                                    <>
                                      <label
                                        htmlFor="example-number-input"
                                        className="col-md-2 col-form-label"
                                      >
                                        <h5 className="text-secondary fw-bold">
                                          {this.props.t("User Photo")}
                                        </h5>
                                      </label>
                                      <div className="col-md-10">
                                        <div
                                          className="dropzone-previews mt-3"
                                          id="file-previews"
                                        >
                                          {this.state.selectedFiles.map(
                                            (f, i) => {
                                              return (
                                                <Card
                                                  className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                                  key={i + "-file"}
                                                >
                                                  <div className="p-2">
                                                    <Row className="align-items-center">
                                                      <Col className="col-auto">
                                                        <img
                                                          data-dz-thumbnail=""
                                                          height="80"
                                                          className="avatar-sm rounded bg-light"
                                                          alt={f.name}
                                                          src={f.preview}
                                                        />
                                                      </Col>
                                                      <Col>
                                                        <Link
                                                          to="#"
                                                          className="text-muted font-weight-bold"
                                                        >
                                                          {f.name}
                                                        </Link>
                                                        <p className="mb-0">
                                                          <strong>
                                                            {f.formattedSize}
                                                          </strong>
                                                        </p>
                                                      </Col>
                                                    </Row>
                                                  </div>
                                                </Card>
                                              );
                                            }
                                          )}
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <></>
                                  )}
                                </>
                              ) : (
                                <>
                                  <label
                                    htmlFor="example-number-input"
                                    className="col-md-2 col-form-label"
                                  >
                                    <h5 className="text-secondary fw-bold">
                                      {this.props.t("User Photo")}
                                    </h5>
                                  </label>
                                  <div className="col-md-10">
                                    <Dropzone
                                      multiple={false}
                                      disabled={this.state.props.isView}
                                      onDrop={acceptedFiles => {
                                        this.handleAcceptedFiles(acceptedFiles);
                                      }}
                                    >
                                      {({ getRootProps, getInputProps }) => (
                                        <div className="dropzone">
                                          <div
                                            className="dz-message needsclick"
                                            {...getRootProps()}
                                          >
                                            <input {...getInputProps()} />
                                            <div className="mb-3">
                                              <i className="display-4 text-muted bx bxs-cloud-upload" />
                                            </div>
                                            <h4>
                                              Drop logo here or click to upload.
                                            </h4>
                                          </div>
                                        </div>
                                      )}
                                    </Dropzone>
                                    <div
                                      className="dropzone-previews mt-3"
                                      id="file-previews"
                                    >
                                      {this.state.selectedFiles.map((f, i) => {
                                        return (
                                          <Card
                                            className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                            key={i + "-file"}
                                          >
                                            <div className="p-2">
                                              <Row className="align-items-center">
                                                <Col className="col-auto thumb">
                                                  <img
                                                    data-dz-thumbnail=""
                                                    height="80"
                                                    className="avatar-sm rounded bg-light thumbInner"
                                                    alt={f.name}
                                                    src={f.preview}
                                                  />
                                                  <button
                                                    type="button"
                                                    onClick={() => {
                                                      this.setState(
                                                        this.state.selectedFiles.pop()
                                                      );

                                                      this.setState([
                                                        ...this.state
                                                          .selectedFiles,
                                                      ]);
                                                    }}
                                                    className="bg-transparent border-0"
                                                  >
                                                    {" "}
                                                    <div className="middle">
                                                      <i className="fa-solid fa-circle-xmark fs-1 bg-white text-secondary"></i>
                                                    </div>
                                                  </button>
                                                </Col>
                                                <Col>
                                                  <Link
                                                    to="#"
                                                    className="text-muted font-weight-bold"
                                                  >
                                                    {f.name}
                                                  </Link>
                                                  <p className="mb-0">
                                                    <strong>
                                                      {f.formattedSize}
                                                    </strong>
                                                  </p>
                                                </Col>
                                              </Row>
                                            </div>
                                          </Card>
                                        );
                                      })}
                                    </div>
                                  </div>
                                </>
                              )}
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="name"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.name && touched.name
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="name"
                                  placeholder="XYZ Diamond"
                                />
                                <ErrorMessage
                                  name="name"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="roleId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Role")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    this.state.props.isView
                                      ? "form-control fs-5" +
                                        (errors.roleId && touched.roleId
                                          ? " is-invalid"
                                          : "")
                                      : "form-control form-select fs-5" +
                                        (errors.roleId && touched.roleId
                                          ? " is-invalid"
                                          : "")
                                  }
                                  disabled={this.state.props.isView}
                                  name="roleId"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    Select
                                  </option>
                                  {this.state.roleList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="roleId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="id"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Employee Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  disabled={true}
                                  className={"form-control fs-5"}
                                  type="text"
                                  name="id"
                                  placeholder=""
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="factoryId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Factory(Unit) Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    this.state.props.isView
                                      ? "form-control fs-5" +
                                        (errors.factoryId && touched.factoryId
                                          ? " is-invalid"
                                          : "")
                                      : "form-control form-select fs-5" +
                                        (errors.factoryId && touched.factoryId
                                          ? " is-invalid"
                                          : "")
                                  }
                                  disabled={this.state.props.isView}
                                  name="factoryId"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select factory Name
                                  </option>
                                  {this.state.factoryList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="factoryId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="userTimeShiftId"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("User Time Shift")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    this.state.props.isView
                                      ? "form-control fs-5" +
                                        (errors.userTimeShiftId &&
                                        touched.userTimeShiftId
                                          ? " is-invalid"
                                          : "")
                                      : "form-control form-select fs-5" +
                                        (errors.userTimeShiftId &&
                                        touched.userTimeShiftId
                                          ? " is-invalid"
                                          : "")
                                  }
                                  disabled={this.state.props.isView}
                                  name="userTimeShiftId"
                                  as="select"
                                >
                                  <option disabled value="">
                                    select user time shift Name
                                  </option>
                                  {this.state.userTimeShiftList?.map(x => (
                                    <option key={x.id} value={x.id}>
                                      {x.name}
                                    </option>
                                  ))}
                                </Field>
                                <ErrorMessage
                                  name="userTimeShiftId"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="gender"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Gender")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  disabled={this.state.props.isView}
                                  id="male"
                                  type="radio"
                                  name="gender"
                                  value="1"
                                  className={
                                    "fs-1" +
                                    (errors.gender && touched.gender
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <Label htmlFor="male">
                                  {" "}
                                  <p className="fs-5 d-inline-block ps-2 pe-4">
                                    Male
                                  </p>
                                </Label>
                                <Field
                                  id="female"
                                  type="radio"
                                  name="gender"
                                  disabled={this.state.props.isView}
                                  value="2"
                                  className={
                                    "fs-1" +
                                    (errors.gender && touched.gender
                                      ? " is-invalid"
                                      : "")
                                  }
                                />
                                <Label htmlFor="female">
                                  <p className="fs-5 d-inline-block ps-2 pe-4">
                                    Female
                                  </p>
                                </Label>
                                <ErrorMessage
                                  name="gender"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo1 && touched.mobileNo1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="mobileNo1"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="mobileNo2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Mobile no.2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.mobileNo2 && touched.mobileNo2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="mobileNo2"
                                  placeholder="+91 (132)(564)(9872)"
                                />
                                <ErrorMessage
                                  name="mobileNo2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="email"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Email ID")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.email && touched.email
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="email"
                                  name="email"
                                  placeholder="xyzdiamond123@gmail.com"
                                />
                                <ErrorMessage
                                  name="email"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="zipCode"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Zip Code")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.zipCode && touched.zipCode
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={
                                    this.state.props.isView ? true : false
                                  }
                                  type="number"
                                  onWheel={e => e.target.blur()}
                                  name="zipCode"
                                  placeholder="Zip code"
                                />
                                <ErrorMessage
                                  name="zipCode"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="password"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("New Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.password && touched.password
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="password"
                                  name="password"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="password"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="confirmpassword"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Confirm Password")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.confirmpassword &&
                                    touched.confirmpassword
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="password"
                                  name="confirmpassword"
                                  placeholder="************"
                                />
                                <ErrorMessage
                                  name="confirmpassword"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine1"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 1")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine1 && touched.addressLine1
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="addressLine1"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine1"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="addressLine2"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("Address line 2")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.addressLine2 && touched.addressLine2
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="addressLine2"
                                  placeholder="1901 Thornridge Cir. Shiloh, Hawaii 81063"
                                />
                                <ErrorMessage
                                  name="addressLine2"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="city"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("City")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.city && touched.city
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  type="text"
                                  name="city"
                                  placeholder="Surat"
                                />
                                <ErrorMessage
                                  name="city"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="state"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {this.props.t("State")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    this.state.props.isView
                                      ? "form-control fs-5" +
                                        (errors.state && touched.state
                                          ? " is-invalid"
                                          : "")
                                      : "form-control form-select fs-5" +
                                        (errors.state && touched.state
                                          ? " is-invalid"
                                          : "")
                                  }
                                  disabled={this.state.props.isView}
                                  name="state"
                                  as="select"
                                >
                                  <option value="" disabled>
                                    select
                                  </option>
                                  <option value="1">Gujarat</option>
                                  <option value="2">Maharashtra</option>
                                  <option value="3">Tamil Nadu</option>
                                  <option value="4">Uttar Pradesh</option>
                                  <option value="5">West Bengal</option>
                                  <option value="6">Karnataka</option>
                                  <option value="7">Rajasthan</option>
                                  <option value="8">Andhra Pradesh</option>
                                  <option value="9">Madhya Pradesh</option>
                                </Field>
                                <ErrorMessage
                                  name="state"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="note"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {" "}
                                  {this.props.t("Notes")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <Field
                                  className={
                                    "form-control fs-5" +
                                    (errors.notes && touched.notes
                                      ? " is-invalid"
                                      : "")
                                  }
                                  disabled={this.state.props.isView}
                                  as="textarea"
                                  name="notes"
                                  rows="7"
                                ></Field>

                                <ErrorMessage
                                  name="notes"
                                  component="div"
                                  className="invalid-feedback"
                                />
                              </div>
                            </div>
                            <div className="mb-3 row">
                              <Label
                                htmlFor="originalProcessName"
                                className="col-md-2 col-form-label"
                              >
                                <h5 className="text-secondary fw-bold">
                                  {" "}
                                  {this.props.t("Original Process Name")}
                                </h5>
                              </Label>
                              <div className="col-md-10">
                                <div className="form-check form-switch d-inline-block">
                                  <Field
                                    className="form-check-input fs-5"
                                    type="checkbox"
                                    name="originalProcessName"
                                    disabled={
                                      this.state.props.isView ? true : false
                                    }
                                  />
                                  <label className="form-check-label pt-4"></label>
                                </div>
                              </div>
                            </div>
                            <div className="col-md-12 text-end">
                              {this.state.props.isView ? (
                                <Link to="/user-list">
                                  <Button color="primary" className="fs-4 px-5">
                                    Back
                                  </Button>
                                </Link>
                              ) : (
                                <Button
                                  color="primary"
                                  className="fs-4 px-5"
                                  type="submit"
                                  onClick={() => {
                                    if (this.state.props.isEdit == false) {
                                      validateForm()
                                        .then(data => {
                                          console.log(data);
                                          if (Object.keys(data).length == 0) {
                                            this.handleSubmit(event, values);
                                          }
                                        })
                                        .catch(err => console.log(err));
                                    } else {
                                      this.handleSubmit(event, values);
                                    }
                                  }}
                                >
                                  Submit
                                </Button>
                              )}
                            </div>
                          </Row>
                        </Form>
                      )}
                    </Formik>
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </Container>
        </div>
      </React.Fragment>
    );
  }
}

export default withTranslation()(AddUser);
